import { render, staticRenderFns } from "./AddMessageReply.vue?vue&type=template&id=b2601156"
import script from "./AddMessageReply.vue?vue&type=script&lang=js"
export * from "./AddMessageReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports